// extracted by mini-css-extract-plugin
module.exports = {"handled":"handled___23ekW","leftRight":"leftRight___CXFAh","Slider":"Slider___gRNB6","rightContent":"rightContent___3sCbV"};